import { SearchBarInputMin } from 'constants/componentsDimension';
import styled from 'styled-components';
import { Input, Group, Text, palette } from '@landr/maestro';

export const GroupItemGrow = styled(Group.Item)<{ inputValueLength: number }>`
    flex-grow: 10;
    min-width: ${SearchBarInputMin};

    ${({ inputValueLength }) =>
        inputValueLength &&
        `
        min-width: 0;
        display: flex;
    `};
    position: relative;
`;

export const InputNoFocusStyle = styled(Input)`
    padding: 0;
    border: 0;

    &:focus-within {
        box-shadow: none;
    }

    /* @maestro-no-token */
    height: 28px;
    min-height: 28px;

    & > input[type='search'] {
        min-width: 0;
        width: ${({ value }) => (value ? `auto` : '100%')};
        padding-left: 0;
        padding-right: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        :disabled {
            color: ${palette('neutral.600')};
            -webkit-text-fill-color: ${palette('neutral.600')};
        }
    }
`;

export const Autocomplete = styled(Group)`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    align-items: center;
    padding: 0;
    border: 0;
    margin: 0;
    line-height: 1;
`;

export const UserInput = styled(Group.Item)`
    opacity: 0;
`;

export const Prediction = styled(Group.Item)``;

export const Inline = styled(Text)`
    white-space: break-spaces;
    display: inline-block;
    font-weight: 400;

    @media screen and (pointer: coarse) {
        font-size: 16px;
    }
    line-height: 1;
`;
